import styled from 'styled-components'

import mediaQueries from 'components/media-queries'

export const StyledHeadline = styled.h1`
  margin: 0 auto;
  padding: 70px 0;
  max-width: 75rem;
  font-family: ${({ theme }) => theme.fonts.semiBold};
  font-size: 24px;
  text-align: center;
  color: ${({ theme }) => theme.colors.blue};

  ${mediaQueries.tablet`
    padding: 65px;
  `}

  ${mediaQueries.mobile`
    padding: 20px;
  `}
`
